import { useTranslation } from '@/shared/core/hooks/use-translation/use-translation.ts'
import type { SkillCardData } from '@/teams/portfolio/components/section/skills-section/skills-data.ts'
import '@/teams/portfolio/components/section/skills-section/skill-card/skill-card.scss'

interface SkillCardProps {
	card: SkillCardData
}

export function SkillCard({ card }: Readonly<SkillCardProps>) {
	const { t } = useTranslation()
	const Icon = card.icon

	return (
		<article className='skill-card' data-testid={'skill-card'}>
			<div className='skill-card__header'>
				<div className='skill-card__icon-wrapper'>
					<Icon aria-hidden='true' className='skill-card__icon' />
				</div>
				<h3 className='skill-card__title'>{t(card.titleKey)}</h3>
			</div>
			<p className='skill-card__description'>{t(card.descriptionKey)}</p>
			<div aria-hidden='true' className='skill-card__divider' />
			<ul className='skill-card__examples'>
				{card.exampleKeys.map((exampleKey) => (
					<li className='skill-card__example' key={exampleKey}>
						<span aria-hidden='true' className='skill-card__example-bullet'>
							•
						</span>
						<span className='skill-card__example-text'>{t(exampleKey)}</span>
					</li>
				))}
			</ul>
		</article>
	)
}
